<ngb-accordion #acc="ngbAccordion" [activeIds]="activeIds">
    <ngb-panel id="ngb-panel-r">
        <ng-template ngbPanelHeader let-opened="opened">
            <div class="accordion-button custom-header justify-content-between"
                 [class.collapsed]="!opened">
                <button ngbPanelToggle class="toggle-details" [ngClass]="{'opened': opened}">
                    <b>{{translate('recommendations')}}</b>
                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 7.90527L7 1.90527L1 7.90527" stroke="#10082F" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="row result-recommendation ">
                <div class="col-12">
                    <h2 *ngIf="!results.free">{{translate('recommendations')}}</h2>
                    <p *ngIf="!results.free">{{translate('subtitle')}}</p>
                    <h2 *ngIf="results.free">{{translate('unlock')}}</h2>
                    <p *ngIf="results.free" [innerHTML]="translate('plan')"></p>
                </div>
                <div class="col-12 result-recommendation-block">
                    <div class="row align-items-end">
                        <app-recommendations-item class="col-12 col-md-6 col-lg-3" [data]="item"
                                                  *ngFor="let item of items"></app-recommendations-item>
                    </div>
                </div>
            </div>

            <div *ngIf="results?.summary" class="summary-text">
                <p *ngFor="let item of results.summary" [innerHTML]="item.text | safeHtml: 'html'">
                </p>
            </div>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
